module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_e/aoj_e-3-f442d8b4ae66b35004398aed8c8a447c.jpg";